import { create } from 'zustand';

export const useReceiptCreateStore = create((set) => ({
  isOpen: false,
  payload: {},
  callback: null, //
  openReceiptCreate: (payload,callback=null) => set({ isOpen: true, payload,callback }),
  close: (result) => set((state) => {
    // Call callback if exists, and clear everything
    if (state.callback) state.callback(result);
    return { isOpen: false, payload: {}, callback: null };
  }),
}));
export const openReceiptCreate = (payload) => {
  const store = useReceiptCreateStore.getState();
  store.openReceiptCreate(payload);
};

export const closeReceiptCreate = () => {
  const store = useReceiptCreateStore.getState();
  store.close();
};